var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-list-item",
    {
      nativeOn: {
        click: function ($event) {
          return _vm.onClick()
        },
      },
    },
    [
      _vm.$wf.isMdUp
        ? _c(
            "w-list-item-text",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    {
                      style: { justifyContent: "center" },
                      attrs: { sm: "6", md: _vm.showTotal ? 3 : 4 },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.saleTypeName) +
                          " " +
                          _vm._s(_vm.computedFriendlyId)
                      ),
                    ]
                  ),
                  _c(
                    "w-col",
                    {
                      staticClass: "status",
                      style: { justifyContent: "center" },
                      attrs: { sm: "6", md: "2" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("localDate")(_vm.invoice.InvoiceDate)) +
                          " "
                      ),
                    ]
                  ),
                  !_vm.additional
                    ? _c(
                        "w-col",
                        {
                          staticClass: "status",
                          style: { justifyContent: "center" },
                          attrs: { sm: "6", md: "2" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("localDate")(_vm.invoice.ExpirationDate)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.showTotal
                    ? _c(
                        "w-col",
                        {
                          style: { justifyContent: "center" },
                          attrs: { sm: "6", md: "2" },
                        },
                        [
                          _vm._v(
                            "€ " +
                              _vm._s(
                                _vm._f("printHumanFloat")(
                                  _vm.invoice.TotalIncVAT
                                )
                              )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "w-col",
                    {
                      style: { justifyContent: "center" },
                      attrs: { sm: "6", md: _vm.showTotal ? 1 : 2 },
                    },
                    [
                      _vm.open
                        ? _c("span", { staticClass: "open" }, [
                            _vm._v(
                              "€ " +
                                _vm._s(
                                  _vm._f("printHumanFloat")(
                                    _vm.invoice.TotalOpen
                                  )
                                )
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm.additional
                    ? _c("w-col", {
                        staticClass: "status",
                        style: { justifyContent: "center" },
                        attrs: { sm: "6", md: "2" },
                      })
                    : _vm._e(),
                  _c("w-col", { attrs: { sm: "6", md: "2" } }, [
                    _c(
                      "div",
                      { style: { textAlign: "right" } },
                      [
                        _vm.canSign && !_vm.isSigned
                          ? _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("sign-tooltip", {
                                      type: _vm.invoice.Type.getDisplayedName(
                                        _vm.i18n.locale
                                      ),
                                    }),
                                    expression:
                                      "$ct('sign-tooltip',{type:invoice.Type.getDisplayedName(i18n.locale)})",
                                  },
                                ],
                                staticClass: "mr",
                                attrs: { icon: "signature" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sign()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("common.uSign")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("download-tooltip"),
                                expression: "$ct('download-tooltip')",
                              },
                            ],
                            staticClass: "mts",
                            attrs: { icon: "file-pdf" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.download()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$ct("download")) + " ")]
                        ),
                        _vm.canPay && _vm.invoice.TotalOpen > 0
                          ? _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("pay-tooltip"),
                                    expression: "$ct('pay-tooltip')",
                                  },
                                ],
                                staticClass: "ml",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.pay()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$ct("pay")) + " ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm.info
                    ? _c(
                        "w-col",
                        { staticClass: "info", attrs: { sm: "12" } },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.parseTemplate(_vm.info, _vm.invoice))
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "mobile" },
            [
              _c(
                "w-row",
                [
                  _c("div", { staticClass: "label-group" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$ct("header.document"))),
                    ]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm.saleTypeName) +
                          " " +
                          _vm._s(_vm.computedFriendlyId)
                      ),
                    ]),
                  ]),
                  _c("w-spacer"),
                  _c("div", { staticClass: "label-group" }, [
                    _c("div", { staticClass: "label right" }, [
                      _vm._v(_vm._s(_vm.$ct("header.incl"))),
                    ]),
                    _c("div", { staticClass: "value right" }, [
                      _vm._v(
                        "€ " +
                          _vm._s(
                            _vm._f("printHumanFloat")(_vm.invoice.TotalIncVAT)
                          )
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c("div", { staticClass: "label-group" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$ct("header.invoice-date"))),
                    ]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm._f("localDate")(_vm.invoice.InvoiceDate))
                      ),
                    ]),
                  ]),
                  _c("w-spacer"),
                  _vm.open
                    ? _c("div", { staticClass: "label-group" }, [
                        _c("div", { staticClass: "label right" }, [
                          _vm._v(_vm._s(_vm.$ct("header.open"))),
                        ]),
                        _c("div", { staticClass: "value right" }, [
                          _vm._v(
                            "€ " +
                              _vm._s(
                                _vm._f("printHumanFloat")(_vm.invoice.TotalOpen)
                              )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c("div", { staticClass: "label-group" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$ct("header.expiration-date"))),
                    ]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm._f("localDate")(_vm.invoice.ExpirationDate))
                      ),
                    ]),
                  ]),
                  _c("w-spacer"),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }